import styled from 'styled-components';
import { sizePx } from '../../../styles';

export const Wrapper = styled.div`
  img {
    cursor: pointer;
    width: ${sizePx.icon30};
  }
`;